export default function MultipleChoiceIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <circle
        cx="12"
        cy="12.0005"
        r="8.25"
        stroke="#5E718D"
        stroke-width="1.5"
      />
    </svg>
  );
}
